import { Image } from 'antd';
import { getApi } from 'apis';
import { getViewMedicineFields } from 'constants/Data';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';
import styles from './index.module.scss';


const ViewGroceriesBody = ({ medicine, closeDrawerByAnimation }: any) => {
  const [category, setCategory] = useState<any>(null);
  const [subCategory, setSubCategory] = useState<any>(null);
  const [doseForm, setDoseForm] = useState<any>(null);
  const [warningTags, setWarningTags] = useState<any>({});

  const medicinesPermissions = useSelector(
    (state: any) => state?.userProfile
  );

  const isImageViewPermission = checkPermission(medicinesPermissions?.data?.permissions, {
    permissionName: 'Images',
    permission: ['view'],
  });

  const canViewImages = isImageViewPermission;


  const fetchCategory = async () => {
    if (medicine?.categoryId) {
      try {
        const data = await getApi(`/category/get-category/${medicine.categoryId}`);
        const categoryData = data.data?.data;
        setCategory(data.data);
        if (categoryData?.subCategories && medicine?.subCategoryId) {
          const matchedSubCategory = categoryData.subCategories.find(
            (subCat: any) => subCat.id === medicine.subCategoryId
          );
          setSubCategory(matchedSubCategory?.subCategoryName || null);
        }
      } catch (error) {
        console.error('Failed to fetch category:', error);
      }
    }
  };

  const fetchDoseForm = async () => {
    if (medicine?.doseFormId) {
      try {
        const data = await getApi(`/dose-form/get-dose-form/${medicine.doseFormId}`);
        setDoseForm(data.data?.data);
      } catch (error) {
        console.error('Failed to fetch dose form:', error);
      }
    }
  };

  const fetchWarningTags = async () => {
    if (medicine?.Warnings) {
      const warnings = medicine.Warnings;
      const warningTagIds = [
        { key: 'liver', id: warnings.liverTagId },
        { key: 'alcohol', id: warnings.alcoholTagId },
        { key: 'driving', id: warnings.drivingTagId },
        { key: 'kidney', id: warnings.kidneyTagId },
        { key: 'lactation', id: warnings.lactationTagId },
        { key: 'pregnancy', id: warnings.pregnancyTagId }
      ];

      const fetchedTags: any = {};

      for (const { key, id } of warningTagIds) {
        if (id) {
          try {
            const response = await getApi(`/warning-tags/${id}`);
            fetchedTags[key] = response.data?.data;
          } catch (error) {
            console.error(`Failed to fetch ${key} warning tag:`, error);
            fetchedTags[key] = null;
          }
        }
      }

      setWarningTags(fetchedTags);
    }
  };

  const fields = getViewMedicineFields(medicine, category?.data, subCategory, doseForm, warningTags);
  const secondaryImages = medicine?.medicineSecondaryImageUrl || [];
  useEffect(() => {
    fetchCategory();
    fetchDoseForm();
    fetchWarningTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch functions are stable per medicine
  }, [medicine?.categoryId, medicine?.doseFormId, medicine?.Warnings]);

  return (
    <div className={styles['side-drawer-body']}>
      <div className={styles['side-drawer-form']}>

        <div className={styles['side-drawer-form__inputs']}>
          {fields.map((field, index) => (
            <div className={styles['input-group']} key={index}>
              <label>{field.label}</label> <span></span>
              <p>{field.value != null && field.value !== '' ? String(field.value) : '-'}</p>
            </div>
          ))}
        </div>

        {canViewImages && (
          <div className={`${styles['input-group']} ${styles['image-row']}`}>
            <label>Images</label>
            <div className={styles['images-container']} style={{ display: 'flex', gap: '20px' }}>

              <div>
                <p>Primary Image</p>
                <Image
                  src={
                    medicine?.medicinePrimaryImageUrl
                      ? `${process.env.REACT_APP_S3_BASE_URL}${medicine.medicinePrimaryImageUrl}`
                      : '/assets/images/noImage.png'
                  }
                  alt="Primary"
                  width={100}
                />
              </div>

              {secondaryImages.length > 0 ? (
                secondaryImages.slice(0, 3).map((url: string, index: number) => (
                  <div key={index}>
                    <p>Secondary {index + 1}</p>
                    <Image
                      src={
                        url
                          ? `${process.env.REACT_APP_S3_BASE_URL}${url}`
                          : '/assets/images/noImage.png'
                      }
                      alt={`Secondary ${index}`}
                      width={100}
                    />
                  </div>
                ))
              ) : (
                [1, 2, 3].map((_, index) => (
                  <div key={index}>
                    <p>Secondary {index + 1}</p>
                    <img
                      src="/assets/images/noImage.png"
                      alt={`Secondary ${index}`}
                      width={100}
                    />
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewGroceriesBody;
